(function() {
  var AutomagicStep;

  AutomagicStep = (function() {
    function AutomagicStep(opt) {
      var ref, ref1, ref2, ref3;
      this.wait = (ref = opt.wait) != null ? ref : null;
      if (typeof opt.when === 'function') {
        this.when = opt.when;
      } else {
        this.when = function() {
          return true;
        };
      }
      this.waitAnother = (ref1 = opt.waitAnother) != null ? ref1 : null;
      if (typeof opt["do"] === 'function') {
        this["do"] = opt["do"];
      } else {
        this["do"] = function() {
          return true;
        };
      }
      this.maxWaitTime = (ref2 = opt.maxWaitTime) != null ? ref2 : 3000;
      this.pollInterval = (ref3 = opt.pollInterval) != null ? ref3 : 200;
    }

    return AutomagicStep;

  })();

}).call(this);
